import React from 'react'
import "./loader.css"
export default function Loader(props) {
    return (
        <span style={props.cumtomStyle} className="Parentloader">
            <p></p>
            <span className="loader4" style={props.Customloader}></span>
        </span>
    )
}